import React from 'react';
import { Typography } from '@material-ui/core';
import { gray2, lightGray } from 'utils/color-styles';

import { CommunityFull } from './types';

export const communityBannerHeight = 366;

export const Banner = ({ community }: { community: CommunityFull }): JSX.Element => {
  const image = community?.tileImage || community?.headerImage;

  return (
    <div style={{ height: communityBannerHeight }}>
      {image ? (
        <img
          alt={community?.title}
          src={image}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: 16,
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            height: '100%',
            backgroundColor: lightGray,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 16,
          }}
        >
          <Typography
            style={{
              color: gray2,
              fontSize: 16,
              fontWeight: 400,
            }}
          >
            No image set yet
          </Typography>
        </div>
      )}
    </div>
  );
};
